import { render, staticRenderFns } from "./EditManagedBy.vue?vue&type=template&id=3b067c54&scoped=true&"
import script from "./EditManagedBy.vue?vue&type=script&lang=js&"
export * from "./EditManagedBy.vue?vue&type=script&lang=js&"
import style0 from "./EditManagedBy.vue?vue&type=style&index=0&id=3b067c54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b067c54",
  null
  
)

export default component.exports